export default __webpack_public_path__ + "static/CrystalLogo-37cd02d951405e137e8050b25e3560a3.svg";